import React, {Fragment, useEffect} from 'react';
//import {MapContainer, Marker, Popup, TileLayer} from 'react-leaflet';
import {Button} from "react-bootstrap";
import {Link} from "react-router-dom";
import {getRestaurantAction, getRestaurantImagesAction} from "../../../../store/actions/RestaurantActions";
import {useDispatch, useSelector} from "react-redux";
import { Rating } from 'react-simple-star-rating'
import missingAvatar from '../../../../../src/images/user/missing.jpg';
import {ReactComponent as WiFi} from '../../../../../src/icons/wifi.svg';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet'
import Clock from "../../../../icons/clock.svg";
import ClockWhite from "../../../../icons/clock-white.svg";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { useTranslation } from 'react-i18next';
import {translateRecord} from "../../../common/utils";

const Restaurant = (props) => {
  const store = useSelector(store => store.restaurants);
  const restaurantData = store.restaurants[props.match.params.id];
  const dispatch = useDispatch();
  const userDetails = JSON.parse(localStorage.getItem('userDetails'));
  const { t } = useTranslation();

  useEffect(() => {
    if (window.location.host === 'gotovo.app' && isDefaultUser()) {
      ReactGA.initialize("G-KHNZTGMRJE");
      ReactGA.send({hitType: "pageview", page: window.location.pathname});
    }
    if (!Object.keys(store.restaurants).includes(props.match.params.id) ||
        !restaurantData.photos || !restaurantData.reviews) {
      dispatch(getRestaurantAction(props.match.params.id));
    }
  }, []);

  function isDefaultUser() {
    return !userDetails || userDetails.userData.role === 'default'
  }

  function working_time(restaurant) {
    let result = '';
    if (restaurant.working_hours.default) {
      if (restaurant.working_hours.default.always_open) {
        return t('alwaysOpen');
      } else {
        result = `${getTime(restaurant.working_hours.default.working_hours[new Date().toLocaleString('en-us', {weekday: 'short'})].start_time)} - ${getTime(restaurant.working_hours.default.working_hours[new Date().toLocaleString('en-us', {weekday: 'short'})].end_time)}`
      }
    } else {
      result = `${getTime(restaurant.working_hours.working_hours[new Date().toLocaleString('en-us', {weekday:'short'})].start_time)} - ${getTime(restaurant.working_hours.working_hours[new Date().toLocaleString('en-us', {weekday:'short'})].end_time)}`
    }
    return result;
  }

  function getTime(time) {
    return time.split(' ')[1];
  }

  function getRestaurantImages() {
    if (restaurantData.photos.length < 2) {
      dispatch(getRestaurantImagesAction(restaurantData, props.history))
    }
  }

  function acceptOutsideOrders() {
    return Object.keys(restaurantData.order_types).filter(o => o !== 'on_table')
      .filter((order_type) => Object.values(restaurantData.order_types[order_type])
        .includes(true)).length > 0
  }

  console.log('storeRestaurant', store);
  console.log('localStorage', localStorage);

  if (Object.keys(store.restaurants).includes(props.match.params.id)) {
    const images = restaurantData.photos;
    return (
      <div>
        <Helmet>
          <title>Gotovo | {translateRecord(restaurantData, 'name')}</title>
        </Helmet>
        <Fragment>
          <div className="row">
            <Fragment>
              <div className="col-lg-4">
                { !!images &&
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card card-body" onClick={getRestaurantImages}
                           style={images.length > 0 ? {position: 'relative', minHeight: '160px', backgroundSize: 'cover',
                               backgroundPosition: 'center',
                               backgroundImage: `linear-gradient(120deg, rgba(21, 13, 3, 0.9) 15%, rgba(22, 15, 6, 0.8) 30%, rgba(24, 17, 9, 0.7) 40%, rgba(31, 22, 11, 0) 100%), 
                      url(${!!store.restaurants[props.match.params.id].main_photo_id ?
                                 images.filter((p) => p.id === restaurantData.main_photo_id)[0].photo
                                 :
                                 images[0].photo})`}
                             :
                             {position: 'relative', minHeight: '160px'}}
                      >
                        <div style={{position: 'absolute', zIndex: 2, left: 0, top: 0, paddingLeft: 'inherit', paddingTop: 'inherit'}}>
                          { !!restaurantData.logo ?
                            <img src={restaurantData.logo}
                                 style={{borderRadius: 10, height: 50, backgroundColor: 'white', padding: 5}} className='mb-2'/>
                          :
                            <h1 style={{color: images.length > 0 || !!userDetails && userDetails.userData.theme === 'dark' ? 'white' : 'inherit'}}
                                className='mb-0'
                            >
                              {translateRecord(restaurantData, 'name')}
                            </h1>}
                          <div className='d-flex align-items-center'>
                            <img src={images.length > 0 || !!userDetails && userDetails.userData.theme === 'dark' ? ClockWhite : Clock}
                                 style={{height: '20px'}} className='mr-1'/>
                            <h4 className='mb-0'
                                style={{color: images.length > 0 || !!userDetails && userDetails.userData.theme === 'dark' ? 'white' : 'inherit'}}>
                              {working_time(restaurantData)}
                            </h4>
                          </div>
                          { !restaurantData.working_hours.default.always_open && restaurantData.working_hours.default.
                            working_hours[new Date().toLocaleString('en-us', {weekday: 'short'})].holiday &&
                          <h3 className='mb-0' style={{color: "#bb1e57", textAlign: 'justify', display: "inline-block"}}>
                            {t('components.home.holiday')}
                          </h3>}
                          <div className='d-flex mt-1' style={{alignItems: "center"}}>
                            { restaurantData.general_rating > 0 ?
                              <Fragment>
                                <span className="rating-number mr-1" style={{color: images.length > 0 ? 'white' : 'inherit'}}>
                                  {restaurantData.general_rating/20}
                                </span>{' '}
                                <Rating className='mb-1' readonly={true} size={20} allowFraction={true}
                                        initialValue={restaurantData.general_rating/20} />
                                {/*<span className="rating-gray ml-1" style={{fontWeight: 400, fontSize: '15px', marginBottom: '3px'}}>*/}
                                {/*  ({store.restaurants[props.match.params.id].ratings_count})*/}
                                {/*</span>*/}
                              </Fragment>
                            :
                              <h3 className="rating-gray">{t('components.home.noRating')}</h3>}
                          </div>
                        </div>
                        <PhotoProvider speed={() => 800}
                                       easing={(type) => (type === 2 ? 'cubic-bezier(0.36, 0, 0.66, -0.56)' : 'cubic-bezier(0.34, 1.56, 0.64, 1)')}
                        >
                          { restaurantData.photos.map((item, index) => (
                            <PhotoView key={index} src={item.photo}>
                              { (restaurantData.main_photo_id === item.id ||
                                !restaurantData.main_photo_id &&
                                !!restaurantData.photos[0] && index === 0) &&
                              <div className="w-100" style={{height: '200px'}}/>}
                            </PhotoView>))}
                        </PhotoProvider>
                      </div>
                    </div>
                  </div>}
                { (!!restaurantData.description || !!restaurantData.description_en) &&
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="profile card card-body px-3 pt-3 restaurant-carusel">
                        <div className="profile-info">
                          <div className="profile-details">
                        <span className="restaurant-description mb-0"
                              dangerouslySetInnerHTML={{__html: translateRecord(restaurantData, 'description')}}/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>}
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="profile-statistics">
                          <div className="text-center">
                            <div className="mt-1">
                              <Link className="btn btn-primary mb-2 w-100 restaurant-actions" style={{position: 'relative'}}
                                    to={`/r/${restaurantData.slug}/menu${!!restaurantData.table ? `/${restaurantData.table.id}` : ''}`}
                              >
                                { acceptOutsideOrders() ?
                                  <span>{t('menu')}, {t('order').toLowerCase()}</span>
                                :
                                  <span>{t('menu')}</span>}
                              </Link>
                              { !!restaurantData.customer_phone && restaurantData.customer_phone.length > 0 &&
                                <Button as='a' href={`tel:+${restaurantData.customer_phone}`}
                                        onClick={() => window.location.href = `tel:+${restaurantData.customer_phone}`}
                                        className="btn-secondary mb-2 w-100 restaurant-actions">
                                  +{restaurantData.customer_phone}{' '}
                                  <i className="fa fa-phone ml-2" style={{fontSize: '25px'}}/>
                                </Button>}
                              <Button as="a" href={`https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${restaurantData.latitude},${restaurantData.longitude}`}
                                      target='_blank'
                                      className="btn btn-secondary mb-2 w-100 restaurant-actions"
                                //onClick={() => window.location.href = `https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${restaurantData.latitude},${restaurantData.longitude}`}
                                //window.open(`google.navigation:q=${store.restaurants[props.match.params.id].latitude},${store.restaurants[props.match.params.id].longitude}` , '_system')}
                                //window.open(`maps:${store.restaurants[props.match.params.id].latitude},${store.restaurants[props.match.params.id].longitude}?q=${store.restaurants[props.match.params.id].latitude},${store.restaurants[props.match.params.id].longitude}`, '_system')}
                              >
                                {t('route')}<i className="fa fa-location-arrow ml-3" style={{fontSize: '25px'}}/>
                              </Button>
                              { restaurantData.website &&
                                <Button as="a" href={restaurantData.website}
                                        className="btn btn-secondary mb-2 w-100 restaurant-actions" target='_blank'>
                                  {t('components.restaurant.website')}
                                  <i className="fa fa-globe ml-3" style={{fontSize: '25px'}}/>
                                </Button>}
                              {(restaurantData.instagram || restaurantData.facebook) &&
                                <>
                                  {/*<h3>{t('components.restaurant.joinUs')}:</h3>*/}
                                  { !!restaurantData.instagram &&
                                    <a href={restaurantData.instagram}
                                      //onClick={() => window.location.href = restaurantData.instagram}
                                      className='btn btn-instagram mb-2 w-100 restaurant-actions' target='_blank'
                                    >
                                      Instagram{' '}
                                      <i className='fa fa-instagram ml-2' style={{fontSize: '22px'}}/>
                                    </a>}
                                  { !!restaurantData.facebook &&
                                    <a href={restaurantData.facebook}
                                      //onClick={() => window.location.href = restaurantData.facebook}
                                      className='btn btn-facebook w-100 restaurant-actions' target='_blank'
                                    >
                                      Facebook{' '}
                                      <i className='fa fa-facebook ml-2' style={{fontSize: '22px'}}/>
                                  </a>}
                                </>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  { !!restaurantData.services && Object.keys(restaurantData.services).length > 0 &&
                    <div className="col-lg-12">
                      <div className="card">
                        <div className="card-header border-0 pb-0">
                          <h3 className="mb-1">{t('components.restaurant.services')}</h3>
                        </div>
                        <div className="card-body pt-3">
                          <div className="profile-news">
                            <div className="profile-skills">
                              { Object.values(restaurantData.services)
                                  .filter((s) => s.kind === 'on_page' || s.kind === 'both').map((service, i) =>
                                <Button className="btn-secondary btn-xs mb-1 mr-1" key={i}>
                                  {translateRecord(service, 'name')} {service.price && <small>{service.price}<small>₴</small></small>}
                                </Button>)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>}
                </div>
              </div>
              <div className="col-lg-8">
                { !!restaurantData.reviews && restaurantData.reviews.length === 0 ?
                  <div className='card'>
                    <div className='card-body'>
                      <h3 className='text-center'>{t('components.restaurant.noReviews')}</h3>
                      <p className='text-center'>{t('components.restaurant.makeOrder')}</p>
                    </div>
                  </div>
                :
                  <p className='text-center'>{t('components.restaurant.makeOrder')}</p>}

                { !!restaurantData.reviews && restaurantData.reviews.map((review,i) => {
                  return (
                    <div className='row' key={i}>
                      <div className='col-12'>
                        <div className="card">
                          <div className="card-body">
                            <div className="review-table p-0 border-0">
                              <div className="row align-items-center">
                                <div className="col-xl-4 col-xxl-4 col-lg-5 col-md-12">
                                  <div className="d-flex align-items-center">
                                    <div className='profile-photo mb-0 mr-3'
                                         style={{backgroundImage: `url(${!!review.user_picture ? review.user_picture : missingAvatar})`,
                                           height: '45px', width: '45px'
                                         }}
                                    />
                                    <div className="card-body p-0">
                                      <h4 className="mb-0">{review.user_name}</h4>
                                      <span className='rating-gray'>{review.created}</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-5 col-xxl-4 col-lg-7 col-md-12 mt-3 mt-lg-0">
                                  <p className="mb-0 fs-14" dangerouslySetInnerHTML={{__html: review.comment}}/>
                                </div>
                                <div
                                  className="col-xl-3 col-xxl-4 col-lg-7 col-md-12 offset-lg-5 offset-xl-0 media-footer mt-xl-0 mt-3">
                                  <div className="row">
                                    <div className="text-xl-center col-xl-7 col-sm-9 col-lg-8 col-6">
                                      <span className="star-review d-inline-block fs-16">
                                        <Rating readonly={true} initialValue={review.rating} />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>)})}
              </div>
            </Fragment>
          </div>
        </Fragment>
      </div>
    );
  } else {
    return <div/>
  }
};

export default Restaurant;